import React, {useEffect, useState} from 'react';
import CircularLoader from "../Common/CircularLoader";
import EmptyListPlaceholder from "../Common/EmptyListPlaceholder";
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    FormControl,
    Grid,
    InputLabel,
    MenuItem,
    Paper,
    Select,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow
} from "@mui/material";
import {ReferenceModelNameEnums} from "../../enums/ReferenceModelNameEnums";
import {useRecordContext} from "react-admin";
import ServiceResponse from "../../interfaces/Service/ServiceResponse";
import EventBus from "../../EventBus";
import {EventBusEventsEnum} from "../../enums/EventBusEventsEnum";
import {CustomSnackbarTypes} from "../Common/CustomSnackBar";
import LocalityService from "../../services/LocalityService";
import LocalityResponse from "../../interfaces/Locality/LocalityResponse";
import {useAppSelector} from "../../store/hooks";
import GroupPermissionFunction from "../../utils/groupPermissionFunction";
import {UserGroupsEnum} from "../../enums/UserGroupsEnum";
// import ResourceSelectDialog from "../Common/ResourceSelectDialog";
// import Cooks from "../Cooks/Cooks";

interface InputProps {}
const localityService = new LocalityService();

const LocalityServicesTab = (props: InputProps) => {

    // const dispatch = useAppDispatch();
    const userDetails = useAppSelector((state) => state.userDetails.value);
    let groupsArray: string[] = userDetails.adminUser.accessGroups;
    let record: LocalityResponse = useRecordContext();
    let [allServices, setAllServices] = useState<any>([]);
    let [selectedService, setSelectedService] = useState<any>(null);
    let [subData, setSubData] = useState<ServiceResponse[]>([]);
    let [isLoading, setIsLoading] = useState<boolean>();
    // const [openShow, setOpenShow] = useState<boolean>(false);
    // const [loading, setLoading] = useState<boolean>(false);
    // const [cooks, setCooks] = useState<any>([]);

    const [open, setOpen] = useState<boolean>(false);
    // const [openCookList, setOpenCookList] = useState(false);
    // const [selectedList, setSelectedList] = useState<any>(null);

    // const handleClose = (recordData: any) => {
    //     setOpenCookList(false);
    //     if(recordData) {
    //         localityService.addCooksToSlc({
    //             referenceId: selectedList?.referenceId,
    //             referenceModelName: selectedList?.referenceModelName,
    //             serviceId: selectedList?.serviceId,
    //             cookId: recordData?.id,
    //         }).then((res) => {
    //             EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
    //                 message: "Added Successfully",
    //                 type: CustomSnackbarTypes.SUCCESS,
    //             });
    //         });
    //     }
    // };

    // const handleSelectCook = (data: any) => {
    //     setOpenCookList(true);
    //     setSelectedList(data);
    //     dispatch(
    //         setCustomSelectOpen({
    //             open: true,
    //         })
    //     );
    // };


    const refreshData = (id: number) => {
        setIsLoading(true)
        localityService.getAllServiceOfferings({
            referenceId: id,
            referenceModelName: ReferenceModelNameEnums.LOCALITY,
        }).then((res) => {
            console.log(res);
            setSubData(res);
            setIsLoading(false);
        }).catch((err) => {
                setIsLoading(false);
        })
    }

    const changeServiceStatus = (serviceId: number, isServing: boolean) => {
        const payload = {
            referenceId: record?.id,
            referenceModelName: ReferenceModelNameEnums.LOCALITY,
            serviceId,
            isServing,
        };
        localityService.createServiceForSlc(payload).then(() => {
            refreshData(record?.id);
            EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                message: "Updated Successfully",
                type: CustomSnackbarTypes.SUCCESS,
            });
        });
    };

    // const changeCookServiceStatus = (serviceId: number, isCookServed: boolean) => {
    //     const payload = {
    //         referenceId: record?.id,
    //         referenceModelName: ReferenceModelNameEnums.LOCALITY,
    //         serviceId,
    //         isCookServed,
    //     };
    //     localityService.changeCookServeForSlc(payload).then(() => {
    //         refreshData(record?.id);
    //         EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
    //             message: "Updated Successfully",
    //             type: CustomSnackbarTypes.SUCCESS,
    //         });
    //     });
    // };

    // const getCooks = (row: any) => {
    //     localityService.getAllSclCooks({
    //         limit: 500,
    //         filters: {
    //             referenceId: row.referenceId,
    //             referenceModelName: row.referenceModelName,
    //             serviceId: row.serviceId,
    //         }
    //     }).then((res: any) => {
    //         setCooks(res?.data);
    //         setLoading(false);
    //     })
    // };

    useEffect(() => {
        if(!record?.id) return;
        refreshData(record?.id);
    }, [record?.id]);

    useEffect(() => {
        localityService.getAllServices().then((res) => {
            setAllServices(res);
        });
    }, []);

    return (
        <div>
            {/*{openCookList &&*/}
            {/*  <ResourceSelectDialog*/}
            {/*    name={"Cooks"}*/}
            {/*    list={Cooks}*/}
            {/*    onClose={handleClose}*/}
            {/*  />*/}
            {/*}*/}
            <Box display={'flex'} justifyContent={'flex-end'} my={3}>
                <Button variant={'contained'} disabled={!GroupPermissionFunction(groupsArray, [UserGroupsEnum.ADMIN, UserGroupsEnum.MANAGER])} onClick={() => {
                    setOpen(true);
                }}>
                    {'Add New Service'}
                </Button>
            </Box>
            {isLoading ?
            <CircularLoader/>
            :
            <div>
                {subData && subData?.length > 0 ? (
                    <TableContainer component={Paper}>
                        <Table>
                            <TableHead>
                                <TableRow>
                                    <TableCell>Id</TableCell>
                                    <TableCell>SLC Name</TableCell>
                                    <TableCell>Service Name</TableCell>
                                    <TableCell align={'center'}>Service Status</TableCell>
                                    <TableCell align={'center'}>Cook Served Satus</TableCell>
                                    <TableCell/>
                                    {/*<TableCell/>*/}
                                    {/*<TableCell/>*/}
                                    {/*<TableCell/>*/}
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {subData?.map((row: ServiceResponse, index) => (
                                    <TableRow
                                        key={row.id}
                                        sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                                    >
                                        <TableCell scope="row">{index + 1}</TableCell>
                                        <TableCell>{row?.slcName}</TableCell>
                                        <TableCell>{row?.serviceName}</TableCell>
                                        <TableCell align={'center'} sx={{
                                            backgroundColor: row?.isServing ? '#90EE90' : '#e53935',
                                        }}>{row?.isServing ? 'YES' : 'No'}</TableCell>
                                        <TableCell align={'center'} sx={{
                                            backgroundColor: row?.isCookServed ? '#90EE90' : '#e53935',
                                        }}>{row?.isCookServed ? 'YES' : 'No'}</TableCell>
                                        {/*<TableCell align={'center'}>*/}
                                        {/*    <Button*/}
                                        {/*        color={row?.isCookServed ? 'error' : 'success'}*/}
                                        {/*        variant={'contained'}*/}
                                        {/*        disabled={!GroupPermissionFunction(groupsArray, [UserGroupsEnum.ADMIN, UserGroupsEnum.MANAGER])}*/}
                                        {/*        onClick={() => {*/}
                                        {/*            EventBus.emitEvent(*/}
                                        {/*                EventBusEventsEnum.SHOW_CONFIRMATION_DIALOG,*/}
                                        {/*                {*/}
                                        {/*                    title: "Are you sure?",*/}
                                        {/*                    message: "Please confirm to change the cook service status",*/}
                                        {/*                    successLabel: "Confirm",*/}
                                        {/*                    failureLabel: "Cancel",*/}
                                        {/*                    onClose: (confirmed: boolean) => {*/}
                                        {/*                        if (confirmed) {*/}
                                        {/*                            changeCookServiceStatus(row?.serviceId, !row?.isCookServed);*/}
                                        {/*                        }*/}
                                        {/*                    }*/}
                                        {/*                }*/}
                                        {/*            );*/}
                                        {/*        }}*/}
                                        {/*    >*/}
                                        {/*        {row?.isCookServed ? 'No Cook Serve' : 'Cook Serve'}*/}
                                        {/*    </Button>*/}
                                        {/*</TableCell>*/}
                                        <TableCell align={'center'}>
                                            <Button
                                                color={row?.isServing ? 'error' : 'success'}
                                                variant={'contained'}
                                                disabled={!GroupPermissionFunction(groupsArray, [UserGroupsEnum.ADMIN, UserGroupsEnum.MANAGER])}
                                                onClick={() => {
                                                    EventBus.emitEvent(
                                                        EventBusEventsEnum.SHOW_CONFIRMATION_DIALOG,
                                                        {
                                                            title: "Are you sure?",
                                                            message: "Please confirm to change the service status",
                                                            successLabel: "Confirm",
                                                            failureLabel: "Cancel",
                                                            onClose: (confirmed: boolean) => {
                                                                if (confirmed) {
                                                                    changeServiceStatus(row?.serviceId, !row?.isServing);
                                                                }
                                                            }
                                                        }
                                                    );
                                                }}
                                            >
                                                {row?.isServing ? 'Mark Not Serviceable' : 'Mark Serviceable'}
                                            </Button>
                                        </TableCell>
                                        {/*<TableCell align={'center'}>*/}
                                        {/*    <Button*/}
                                        {/*        color={'primary'}*/}
                                        {/*        variant={'contained'}*/}
                                        {/*        onClick={() => {handleSelectCook(row)}}*/}
                                        {/*    >*/}
                                        {/*        {'Add Cook'}*/}
                                        {/*    </Button>*/}
                                        {/*</TableCell>*/}
                                        {/*<TableCell align={'center'}>*/}
                                        {/*    <Button*/}
                                        {/*        color={'primary'}*/}
                                        {/*        variant={'contained'}*/}
                                        {/*        onClick={() => {*/}
                                        {/*            setOpenShow(true);*/}
                                        {/*            setSelectedList(row);*/}
                                        {/*            setLoading(true);*/}
                                        {/*            getCooks(row);*/}
                                        {/*        }}*/}
                                        {/*    >*/}
                                        {/*        {'Show Cooks'}*/}
                                        {/*    </Button>*/}
                                        {/*</TableCell>*/}
                                    </TableRow>
                                ))}
                            </TableBody>
                        </Table>
                    </TableContainer>
                   ) : (
                    <EmptyListPlaceholder
                        message='No Services found'
                    />
                )}
            </div>}
            <Dialog
                onClose={() => {setOpen(false)}}
                open={open}
                scroll={"paper"}
                maxWidth="xs"
                fullWidth
            >
                <DialogTitle>Add New Service</DialogTitle>
                <DialogContent>
                    <Grid
                        container
                        spacing={2}
                        direction="column"
                        justifyContent={"space-evenly"}
                        style={{ padding: "12px 12px 12px 12px" }}
                    >
                        <Grid item>
                            <FormControl fullWidth >
                                <InputLabel id="for_slot">Select Service</InputLabel>
                                <Select
                                    labelId="for_slot"
                                    id="Select Service"
                                    label="Select Service"
                                    value={selectedService}
                                    onChange={(event) => setSelectedService(event.target.value)}
                                >
                                    {allServices.map((e: any) => (
                                        <MenuItem key={e.name} value={e}>
                                            {e.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions style={{ marginTop: "12px" }}>
                    <Button
                        variant="contained"
                        onClick={() => {
                            if(!selectedService){
                                EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                                    message: "Select to proceed",
                                    type: CustomSnackbarTypes.WARNING,
                                });
                                return;
                            }
                            const payload = {
                                referenceId: record?.id,
                                referenceModelName: ReferenceModelNameEnums.LOCALITY,
                                serviceId: selectedService?.id,
                                isServing: true,
                            };
                            localityService.createServiceForSlc(payload).then(() => {
                                setOpen(false);
                                refreshData(record?.id);
                                setSelectedService(null);
                                EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {
                                    message: "Added Successfully",
                                    type: CustomSnackbarTypes.SUCCESS,
                                });
                            });
                        }}
                        size={"large"}
                    >
                        Add
                    </Button>
                    <Button
                        variant="contained"
                        color={"error"}
                        onClick={() => {
                            setOpen(false);
                        }}
                        size={"large"}
                    >
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>

            {/*<Dialog*/}
            {/*    onClose={() => {setOpenShow(false)}}*/}
            {/*    open={openShow}*/}
            {/*    scroll={"paper"}*/}
            {/*    maxWidth="sm"*/}
            {/*    fullWidth*/}
            {/*>*/}
            {/*    <DialogTitle>All SLC Cooks</DialogTitle>*/}
            {/*    <DialogContent>*/}
            {/*        <Box>*/}
            {/*            <Table size={'small'}>*/}
            {/*                <TableHead>*/}
            {/*                    <TableRow>*/}
            {/*                        <TableCell>Id</TableCell>*/}
            {/*                        <TableCell>Name</TableCell>*/}
            {/*                        <TableCell>Cook Type</TableCell>*/}
            {/*                        <TableCell>Service Name</TableCell>*/}
            {/*                        <TableCell>SLC Name</TableCell>*/}
            {/*                        <TableCell>Action</TableCell>*/}
            {/*                    </TableRow>*/}
            {/*                </TableHead>*/}
            {/*                {cooks.length > 0 ?*/}
            {/*                    cooks.map((each: any)=> {*/}
            {/*                        return(*/}
            {/*                            <TableBody key={each?.id}>*/}
            {/*                                <TableRow>*/}
            {/*                                    <TableCell>*/}
            {/*                                        {each?.cookFullProfile?.cookId}*/}
            {/*                                    </TableCell>*/}
            {/*                                    <TableCell>*/}
            {/*                                        {each?.cookFullProfile?.firstName + ' ' + each?.cookFullProfile?.lastName}*/}
            {/*                                    </TableCell>*/}
            {/*                                    <TableCell>*/}
            {/*                                        {each?.cookFullProfile?.isMgCook ? 'MG_COOK' : 'PART_TIME'}*/}
            {/*                                    </TableCell>*/}
            {/*                                    <TableCell>*/}
            {/*                                        {each?.serviceName}*/}
            {/*                                    </TableCell>*/}
            {/*                                    <TableCell>*/}
            {/*                                        {each?.slcName}*/}
            {/*                                    </TableCell>*/}
            {/*                                    <TableCell>*/}
            {/*                                        <Button*/}
            {/*                                            size={'small'}*/}
            {/*                                            color={'error'}*/}
            {/*                                            variant={'contained'}*/}
            {/*                                            onClick={() => {*/}
            {/*                                                EventBus.emitEvent(*/}
            {/*                                                    EventBusEventsEnum.SHOW_CONFIRMATION_DIALOG,*/}
            {/*                                                    {*/}
            {/*                                                        title: "Are you sure?",*/}
            {/*                                                        message: "Please confirm to remove the cook",*/}
            {/*                                                        successLabel: "Confirm",*/}
            {/*                                                        failureLabel: "Cancel",*/}
            {/*                                                        onClose: (confirmed: boolean) => {*/}
            {/*                                                            if (confirmed) {*/}
            {/*                                                                localityService.removeSlcCooks({*/}
            {/*                                                                    referenceId: selectedList?.referenceId,*/}
            {/*                                                                    referenceModelName: selectedList?.referenceModelName,*/}
            {/*                                                                    serviceId: selectedList?.serviceId,*/}
            {/*                                                                    cookId: each?.cookId,*/}
            {/*                                                                }).then(() => {*/}
            {/*                                                                    EventBus.emitEvent(EventBusEventsEnum.SNACKBAR_SHOW, {*/}
            {/*                                                                        message: "Removed Successfully",*/}
            {/*                                                                        type: CustomSnackbarTypes.SUCCESS,*/}
            {/*                                                                    });*/}
            {/*                                                                    getCooks(selectedList);*/}
            {/*                                                                })*/}
            {/*                                                            }*/}
            {/*                                                        }*/}
            {/*                                                    }*/}
            {/*                                                );*/}
            {/*                                            }}*/}
            {/*                                        >*/}
            {/*                                            {'Remove'}*/}
            {/*                                        </Button>*/}
            {/*                                    </TableCell>*/}
            {/*                                </TableRow>*/}
            {/*                            </TableBody>*/}
            {/*                        )*/}
            {/*                    })*/}
            {/*                    : (loading ?*/}
            {/*                            ''*/}
            {/*                            : <caption>No cooks found</caption>*/}
            {/*                    )}*/}
            {/*            </Table>*/}
            {/*        </Box>*/}
            {/*    </DialogContent>*/}
            {/*</Dialog>*/}
        </div>
    );
};

export default LocalityServicesTab;
